import { OrderStatus } from "@tastyworks/tastyworks-api"
import { writable } from "svelte/store"

const defaultOrderStatus = new OrderStatus("", "")

const store = writable(structuredClone(defaultOrderStatus))

export const selectedOrder = {
  ...store,
  reset: () => store.set(structuredClone(defaultOrderStatus)),
}
